module.exports = __webpack_public_path__ + "static/media/avatar.ebd3e55a.png";